module.exports = __webpack_public_path__ + "img/5.7c615406.jpg";